import { render, staticRenderFns } from "./WorkersSelection.vue?vue&type=template&id=2af3a08c&"
import script from "./WorkersSelection.vue?vue&type=script&lang=js&"
export * from "./WorkersSelection.vue?vue&type=script&lang=js&"
import style0 from "./WorkersSelection.vue?vue&type=style&index=0&id=2af3a08c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports